import { z } from 'zod';
import { PAGINATION_PAGE_SIZE_DEFAULT } from '~/constants';

import { withoutObjectKeysWhereValueIs } from '@vestigas/utils';

export const zodUsersInAccountQueryParamsSchema = z
  .object({
    companyAccountId: z.uuid().optional(),
    limit: z.coerce
      .number()
      .gte(1)
      .max(100)
      .prefault(PAGINATION_PAGE_SIZE_DEFAULT)
      .catch(PAGINATION_PAGE_SIZE_DEFAULT),
    offset: z.coerce.number().nonnegative().prefault(0).catch(0),
  })
  .transform((data) =>
    withoutObjectKeysWhereValueIs(data, [null, undefined, '']),
  );
